import React from 'react';

// Global styles
import './src/styles.css';

// Prism code highlighting styles
import './src/themes/prism.css';

export const wrapPageElement = ({ element, props }) => {
  return element;
};
